import _ from "lodash";

// New size bucket format: "1-10", "11-50", "51-200", "201-500", "501-1,000", "1,001-5,000", "5,001-10,000", "10,000+"
// Old format: "very-small-10-20", "small-10-20", "static-0"
const SIZE_BUCKET_REGEX = /^(\d[\d,]*)\+?$/; // matches "10,000+" or just numbers with commas
const SIZE_RANGE_REGEX = /^(\d[\d,]*)-(\d[\d,]*)$/; // matches "1-10" or "1,001-5,000"

export const extractNameRates = (text) => {
  if (!text) return;

  // Check if it's a new format size bucket (just numbers, no name prefix)
  // Format: "1-10", "501-1,000", "10,000+"
  if (SIZE_RANGE_REGEX.test(text)) {
    const match = text.match(SIZE_RANGE_REGEX);
    return {
      name: null,
      from: match[1],
      to: match[2],
    };
  }

  // Handle "10,000+" format
  if (SIZE_BUCKET_REGEX.test(text) && text.includes("+")) {
    const match = text.match(/^(\d[\d,]*)\+$/);
    if (match) {
      return {
        name: null,
        from: match[1],
        to: null,
      };
    }
  }

  // Fall back to old format parsing: "very-small-10-20", "small-10-20", "static-0"
  const parts = text.split("-");

  if (parts.length === 2) { // example: static-0
    return {
      name: _.startCase(parts[0]),
      from: parts[1],
      to: parts[1],
    }
  }

  const to = parts.pop()
  const from = parts.pop()
  const name = _.startCase(parts.join(" "))

  return {
    name,
    from,
    to,
  }
}
